import React from "react";
import { Wrapper, Container, HealthConditionCard } from "./templateStyle";
import PropTypes from "prop-types";
function BodyTemplate(
  { isBelowHeroSection, isLastSection, children, isForm, p = "38px 40px" },
  ref
) {
  return (
    <Wrapper
      isBelowHeroSection={isBelowHeroSection}
      isLastSection={isLastSection}
      ref={ref}
    >
      <Container>
        <HealthConditionCard isForm={isForm} p={p}>
          {children}
        </HealthConditionCard>
      </Container>
    </Wrapper>
  );
}

export default React.forwardRef(BodyTemplate);

BodyTemplate.propTypes = {
  isForm: PropTypes.bool,
  isBelowHeroSection: PropTypes.bool,
  isLastSection: PropTypes.bool,
};
BodyTemplate.defaultProps = {
  isForm: false,
  isLastSection: false,
  isBelowHeroSectionL: false,
};
